import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import { ChildScores } from '../../../typings';

export function getChildrenScores(clessonId: number, childrenIds: number[]): Promise<ChildScores> {
    const { apiGetChildrenScores } = apiConfig.getStaticUrls();

    return getFetch(`${apiGetChildrenScores}${clessonId}/`, { children_ids: childrenIds });
}
